module.exports = __webpack_public_path__ + "3f25bd22c4580d929d2f96b66a89bc67.pdf";